export default "__VITE_ASSET__B_F78Yyz__"